import { render, staticRenderFns } from "./nonMerStep5.vue?vue&type=template&id=a3fcfd70&scoped=true&"
import script from "./nonMerStep5.vue?vue&type=script&lang=js&"
export * from "./nonMerStep5.vue?vue&type=script&lang=js&"
import style0 from "./nonMerStep5.vue?vue&type=style&index=0&id=a3fcfd70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fcfd70",
  null
  
)

export default component.exports